import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_85: FaireProductEntity = {
  token: "starter_collection_85",
  type: "product",
  name: "Crossback Denim Apron",
  brandName: "Hedley & Bennett",
  imageUrl:
    "https://cdn.faire.com/fastly/5b000a38b29fd6ace19dca2e0a7aa04abf44050635777ed470131604717df48c.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 110,
  msrpDollars: 220,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
